import { render, staticRenderFns } from "./H5Tables.vue?vue&type=template&id=5fc85604&scoped=true&"
import script from "./H5Tables.vue?vue&type=script&lang=js&"
export * from "./H5Tables.vue?vue&type=script&lang=js&"
import style0 from "./H5Tables.vue?vue&type=style&index=0&id=5fc85604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc85604",
  null
  
)

export default component.exports